export class Notification {
  // The type of message to display
  type: 'error' | 'warning' | 'info' | 'success';
  // Optional title to display: Default: none
  title?: string;
  // The message to display. This must be specified
  message: string;
  // Allow user to manually close the notification. Default: true
  hideOnClick?: boolean;
  // The time (in milliseconds) to show the nofitification. Default: 5000
  hideDelay?: number;
  // Used to avoid HTML injection
  messageSanitized?: string;
}
